export default __webpack_public_path__ + "static/media/Uk.da5a98ee.png";